import * as React from 'react';
import { useSelector } from 'react-redux';
import { currentOpenChatSelector } from '../../../../../selectors';
import { useMessageContext } from '../../../../../utils/messageContext';
import { ChatImageContainer } from '../../../../ChatImageContainer';
import { ChatImageDraftContainer } from '../../../../ChatImageDraftContainer';
import { MessageImagesLayout } from '../../../../../components/MessageImagesLayout';

export const useMessageImages = (): React.ReactNode => {
  const {
    messageId,
    message: { files, status },
    chatId,
  } = useMessageContext();
  const imageFiles = files?.images;

  const { pendingFiles } = useSelector(currentOpenChatSelector) || {};

  return React.useMemo(() => {
    const blobFiles = pendingFiles?.[messageId]?.blobFiles || [];
    const imageBlobFiles = blobFiles.filter(({ type }) => type === 'image');

    if (imageBlobFiles.length) {
      const nodes = imageBlobFiles.map(({ file, cancellationToken }) => (
        <ChatImageDraftContainer
          key={file?.lastModified}
          file={file}
          messageId={messageId}
          cancellationToken={cancellationToken}
          messageStatus={status}
          isGalleryItem={imageBlobFiles.length > 1}
        />
      ));

      const isGallery = imageBlobFiles.length > 1;

      if (isGallery) {
        return <MessageImagesLayout images={nodes} uniqueKey={`${chatId}_${messageId}`} />;
      }

      return nodes[0];
    }

    if (imageFiles?.length) {
      const nodes = imageFiles.map(image => (
        <ChatImageContainer key={image.uid} image={image} isGalleryItem={imageFiles.length > 1} withFullscreen />
      ));

      const isGallery = imageFiles.length > 1;

      if (isGallery) {
        return <MessageImagesLayout images={nodes} uniqueKey={`${chatId}_${messageId}`} />;
      }

      return nodes[0];
    }

    return null;
  }, [imageFiles, messageId, status, pendingFiles, chatId]);
};
